import { useLenis } from "../../hooks/useLenis";
import { CustomCursor } from "../CustomCursor";
import { Portal } from "../../pages/Portal";
import { SomaticPlayer } from "../portal/SomaticPlayer";
import { ChatWidget } from "../portal/ChatWidget";

export const Layout = () => {
  useLenis();
  return (
    <div id="top" className="relative min-h-screen overflow-x-hidden bg-[#0A2E2C] text-[#F8FAFC]">
      <div className="grain-overlay" aria-hidden="true" />
      <CustomCursor />
      <main>
        <Portal />
      </main>
      <SomaticPlayer />
      <ChatWidget />
    </div>
  );
};
